import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { RegistrationSliceState } from './state';
import { registrationEndpoints } from '../endpoints/registrationEndpoints';

/**
 * Build extra reducers for handling async actions from RTK Query endpoints
 */
export const buildExtraReducers = (builder: ActionReducerMapBuilder<RegistrationSliceState>) => {
  builder.addMatcher(
    registrationEndpoints.endpoints.getRegistration.matchFulfilled,
    (state, action) => {
      state.currentRegistration = action.payload;
      state.isEdited = false;
      state.editedFields = [];
      state.validationErrors = {};
    }
  );
};
